import firestore from "../../../firebase/firestore";

export default {
  resetFilter({ commit }) {
    commit("resetState");
    commit("setPlans", []);
    commit("setPlan", null);
  },
  getPlans({ commit }, person_type) {
    // console.log('getPlans')
    let today = new Date();
    commit("setPlans", []);

    let plansRef = firestore.collection("plans");
    let _plans = [];
    return plansRef
      .where("status", "==", "activated")
      .where("started_at", "<=", today)
      .where("person_type", "==", person_type)
      .where("status", "==", "activated")
      .get()
      .then((res) => {
        if (res.size <= 0)
          return { status: false, message: "Planos não encontrados!" };
        for (let i = 0; i < res.size; i++) {
          let _plan = {
            id: res.docs[i].id,
            ...res.docs[i].data(),
          };
          _plans.push(_plan);
          if (_plan.recommended) commit("setPlan", _plan);
        }
        commit("setPlans", _plans);
        return { status: true, plans: _plans };
      })
      .catch((err) => {
        console.error(err);
        return { status: false, message: "Erro ao buscar o cupom" };
      });
  },
};
